<template>
  <div>
    <el-dialog append-to-body :visible.sync="visible" title="Chọn lô nhập hàng sản phẩm" :close-on-click-modal="false" width="70%">
      <div>
        <el-select v-model="batch" placeholder="Tìm kiếm theo mã lô" filterable class="width">
          <el-option v-for="(batch, index) in batchs" :key="index" :label="batch.labelSelect" :value="batch">
          </el-option>
        </el-select>
        <el-table :data="batchSelect" style="width: 100%">
          <el-table-column property="batchCode" label="Mã lô" />
          <el-table-column property="manufactureDate" label="Ngày sản xuất">
            <template slot-scope="scope">
              {{ timeFormatDate(scope.row.manufactureDate) }}
            </template>
          </el-table-column>
          <el-table-column property="expirationDate" label="Hạn sử dụng">
            <template slot-scope="scope">
              {{ timeFormatDate(scope.row.expirationDate) }}
            </template>
          </el-table-column>
          <el-table-column property="quantity" label="Tồn kho" />
          <el-table-column property="quantityChoose">
            <template slot="header">
              <div class="label-is-required">
                Số lượng
              </div>
            </template>
            <template slot-scope="scope">
              <b-form  @submit.stop.prevent>
                <b-form-input v-model="scope.row.quantityChoose" :state="scope.row.validQuantityChoose" @input="validateQuantityChoose(scope.row)" @keydown="allowNumbersOnly" placeholder="Nhập số lượng" style="height: 40px;"></b-form-input>
                <b-form-invalid-feedback :state="scope.row.validQuantityChoose">
                  {{ validateQuantityChooseText }}
                </b-form-invalid-feedback>
              </b-form>
            </template>
          </el-table-column>
          <el-table-column prop="" width="50">
            <template slot-scope="scope">
              <i class="el-icon-close btn-icon color-danger" @click="handleRemove(scope.row)"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <el-button type="text" @click="visible = false">Thoát</el-button>
        <el-button type="primary" @click="confirmSelect" :disabled="allowConfirm">Hoàn tất</el-button>
      </template>
    </el-dialog>
    <el-button @click="handleModal()">
      Chọn số lô - HSD <i class="el-icon-arrow-right" style="padding-left: 50px;"/>
    </el-button>
  </div>
</template>

<script>
import { itemGetBatchBySKU } from '@/api/items'
import { formatDDMMYYYY } from '../../utils/format'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      validateQuantityChooseText: '',
      valueSearch: '',
      batchSelect: [],
      batchs: [],
      batch: {},
      visible: false
    }
  },
  watch: {
    batch() {
      this.handleSelect(this.batch)
    }
  },
  computed: {
    allowConfirm() {
      return !this.batchSelect.length > 0
    }
  },
  methods: {
    validateQuantityChoose(item) {
      if (item.quantityChoose) {
        item.validQuantityChoose = null
        this.validateQuantityChooseText = ''
        if (Number(item.quantityChoose) > item.quantity) {
          //item.validQuantityChoose = false
          //this.validateQuantityChooseText = 'Không được vượt quá tồn'
        }
      } else {
        item.validQuantityChoose = false
        this.validateQuantityChooseText = 'không được để trống'
      }
    },
    handleModal() {
      this.visible = true
      // API: get expried by Item
      const param = {
        queryString: `{sku}=='''${this.item.sku}'''`,
        limit: 100,
        lastIndex: '',
        sortField: '',
        sortValue: ''
      }
      itemGetBatchBySKU(param).then(res => {
        if (res.success && res.data.productBatches.length > 0) {
          const batchs = res.data.productBatches[0].stockQuantities[0].batch
          const response = batchs.map(batch => {
            return {
              ...batch,
              quantityChoose: 1,
              value: batch.batchCode,
              labelSelect: `${batch.batchCode} - HSD: ${formatDDMMYYYY(batch.expirationDate)}`
            }
          })
          this.batchs = response
          this.batchSelect = this.selected.map(select => {
            return {
              ...select,
              labelSelect: `${select.batchCode} - HSD: ${formatDDMMYYYY(select.expirationDate)}`,
              validQuantityChoose: null
            }
          })
        }
      })
    },
    handleSelect(item) {
      const checkExist = this.batchSelect.find(expire => expire.batchCode === item.batchCode)
      if (checkExist) {
        this.$notify({
          title: 'Thống báo',
          message: 'Đã tồn tại thông tin này trong danh sách',
          type: 'warning'
        })
      } else {
        this.batchSelect.unshift({...item, validQuantityChoose: null})
      }
    },
    handleRemove(item) {
      const getIndex = this.batchSelect.findIndex(expire => expire.batchCode === item.batchCode)
      if (getIndex !== -1) {
        this.batchSelect.splice(getIndex, 1)
      }
    },
    confirmSelect() {
      //validate số lượng chọn
      const valid = this.batchSelect.filter(batch => batch.validQuantityChoose == false)
      if (valid.length > 0) {
        return
      }
      this.visible = false
      this.$emit('batchSelect', { item: this.item, batchs: this.batchSelect.map(batch => {
        return {
          ...batch,
          label: `${batch.labelSelect} - SL: ${batch.quantityChoose}`
        }
      })})
    }
  }
}
</script>

<style>

</style>